function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-969.983 -406.823)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M186.083.237c91.2-19.191,185.877,120.245,129.763,188.087s-77.24,158.4-144.14,152.115S0,266.747,0,171.926C-.809,34.78,129.805,29.169,186.083.237Z",
  transform: "translate(969.986 408.382)",
  fill: "#ebebeb"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-5 3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-.567-.5h27l-.959,8.59L26,11.531l.017,40-.557,3L26.56,63h-27L.638,54.533l-.636-3-.023-40L.626,8.094Z",
  transform: "translate(1164 538)",
  fill: "#b5c7df"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-.567-.5h27l-.959,8.59L26,11.531l.017,40-.557,3L26.56,63h-27l1.958-8.468-.451-3v-40l.451-3.437Z",
  transform: "translate(1121 538)",
  fill: "#b5c7df"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-.567-.5h27l-.959,8.59L26,11.531l.017,40-.557,3L26.56,63h-27L.638,54.533l-.636-3-.023-40L.626,8.094Z",
  transform: "translate(1080 538)",
  fill: "#b5c7df"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-95 -13)"
}, /*#__PURE__*/React.createElement("line", {
  x2: 159,
  transform: "translate(1151.5 542.5)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 159,
  transform: "translate(1151.5 621.5)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 169,
  transform: "translate(1146.5 633.5)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 185,
  transform: "translate(1138.5 645.5)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M8738.5,1570.228l79.923-30.95,78.665,30.95",
  transform: "translate(-7587 -1039)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M8738.5,1558.626l49.965-19.349,49.179,19.349",
  transform: "translate(-7557.277 -1026.199)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8738.5,1596.318h30.063l-6.142-7.627H8744.61Z",
  transform: "translate(-7587 -982.691)",
  fill: "#3a76c4",
  stroke: "#3a76c4",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M8738.5,1588.691h30.063l-6.142,7.627H8744.61Z",
  transform: "translate(-7587 -1037.691)",
  fill: "#3a76c4",
  stroke: "#3a76c4",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  y1: 40,
  transform: "translate(1166.5 562.5)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 17
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(42)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8738.5,1596.318h30.063l-6.142-7.627H8744.61Z",
  transform: "translate(-7587 -982.691)",
  fill: "#3a76c4",
  stroke: "#3a76c4",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M8738.5,1588.691h30.063l-6.142,7.627H8744.61Z",
  transform: "translate(-7587 -1037.691)",
  fill: "#3a76c4",
  stroke: "#3a76c4",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  y1: 40,
  transform: "translate(1166.5 562.5)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 17
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(84)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8738.5,1596.318h30.063l-6.142-7.627H8744.61Z",
  transform: "translate(-7587 -982.691)",
  fill: "#3a76c4",
  stroke: "#3a76c4",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M8738.5,1588.691h30.063l-6.142,7.627H8744.61Z",
  transform: "translate(-7587 -1037.691)",
  fill: "#3a76c4",
  stroke: "#3a76c4",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  y1: 40,
  transform: "translate(1166.5 562.5)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 17
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(127)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8738.5,1596.318h30.063l-6.142-7.627H8744.61Z",
  transform: "translate(-7587 -982.691)",
  fill: "#3a76c4",
  stroke: "#3a76c4",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M8738.5,1588.691h30.063l-6.142,7.627H8744.61Z",
  transform: "translate(-7587 -1037.691)",
  fill: "#3a76c4",
  stroke: "#3a76c4",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  y1: 40,
  transform: "translate(1166.5 562.5)",
  fill: "none",
  stroke: "#3a76c4",
  strokeWidth: 17
})))));

var SvgHistoryEmptyStateIcon = function SvgHistoryEmptyStateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332.68,
    height: 342.308,
    viewBox: "0 0 332.68 342.308",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHistoryEmptyStateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HistoryEmptyStateIcon.aa635edd.svg";
export { ForwardRef as ReactComponent };